import { CalendarIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { applyDateMask } from '@clickersphere/core/utils/parseDate';
import DayPicker from './DayPicker';
import { Input } from './Input';
import { Popover } from './Popover';

interface IDateInputProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
}

export default function DateInput({
  name,
  value,
  onChange,
  placeholder,
  error,
  disabled,
}: IDateInputProps) {
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);

  function toggleCalendarVisibility() {
    setIsCalendarVisible((prev) => !prev);
  }

  return (
    <Input
      name={name}
      inputMode="numeric"
      maxLength={10}
      value={value}
      onChange={(e) => onChange(applyDateMask(e.target.value))}
      placeholder={placeholder}
      error={error}
      disabled={disabled}
    >
      <Popover.Root
        open={isCalendarVisible}
        onOpenChange={setIsCalendarVisible}
      >
        <Popover.Trigger
          className="text-text-tertiary absolute top-3 left-full -translate-x-10 cursor-pointer"
          onClick={toggleCalendarVisibility}
          disabled={disabled}
        >
          <CalendarIcon />
        </Popover.Trigger>
        <Popover.Content side="right" sideOffset={24} alignOffset={24}>
          <DayPicker
            selectedDate={value}
            onSelect={(selected) => {
              onChange(selected);
              toggleCalendarVisibility();
            }}
          />
        </Popover.Content>
      </Popover.Root>
    </Input>
  );
}
